<div class="toolbar-container">
  <div class="toolbar">
    <div class="title">
      <div class="pi pi-sync sync-icon" (click)="onRefreshClicked()"></div>
      <div class="lastupdate-text">Updated:
        <div *ngIf="lastUpdatedTb else skeleton">
          {{lastUpdatedTb}}
        </div>
      </div>
      <ng-template #skeleton>
        <p-skeleton width="30px" height="17px"></p-skeleton>
      </ng-template>
    </div>
    <div class="icon-container">
      <div class="row" *ngIf="appSettings$ | async as appSettings">
        <i class="sort-icon {{appSettings.sortOrder === 0 ? 'pi pi-arrow-up' : 'pi pi-arrow-down'}}"></i>
        <div [ngClass]="{'flt-icon': (appSettings.filter.flights), 
               'inactive-icon': (!appSettings.filter.flights) }">F</div>
        <div [ngClass]="{'dh-icon': (appSettings.filter.deadhead), 
               'inactive-icon': (!appSettings.filter.deadhead) }">D</div>
        <div [ngClass]="{'cx-icon': (appSettings.filter.cancelled), 
               'icon-inactive': (!appSettings.filter.cancelled) }">C</div>
      </div>
      <i class="bi-filter filter-icon" (click)="onOpenDialog('filter')"></i>
      <i class="pi pi-question-circle help-icon" (click)="onOpenDialog('legend')"></i>
    </div>
  </div>
</div>